import { render, staticRenderFns } from "./MenuTeamSettingList.vue?vue&type=template&id=2e0e3d19&scoped=true"
var script = {}
import style0 from "./MenuTeamSettingList.vue?vue&type=style&index=0&id=2e0e3d19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0e3d19",
  null
  
)

export default component.exports